import { ref } from "vue";

const saveCampaignButtonRef = ref();

const sharedRefs = {
  saveCampaignButtonRef
};

export default sharedRefs;